import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { ToolsListContainer, ToolsMenuContainer } from "./style";
import {
  TOOL_MAIN_OPTIONS,
  TOOL_FOOTER_OPTIONS,
  TOOL_HEADER_1_OPTIONS,
  TOOL_HEADER_2_OPTIONS
} from "../../../../../constants/toolsOptions";
import { Menu } from "../menu";
import { EXPIRED_PREMIUM, FREE } from "../../../../../constants/premiumState";
import FeatureDeniedModal from "../../../../../containers/app/components/accessDeniedOrReminderModals/featureDeniedModal";

class Index extends Component {
  state = {
    featureLimitModalShow: false
  };
  render() {
    const { init } = this.props;
    const { featureLimitModalShow } = this.state;
    return (
      <React.Fragment>
        <FeatureDeniedModal
          status={featureLimitModalShow}
          title="دریافت فایل"
          description="شما یک ویژگی حرفه‌ای را پیدا کرده‌اید! امکان دریافت خروجی فایل و بسیاری امکانات دیگر در اشتراک حرفه‌ای مپسا در دسترس می‌باشد."
          handleShow={show => this.setState({ featureLimitModalShow: show })}
        />
        <Menu
          showMenu={this.props.show}
          close={() => this.props.handleShow(false)}
          isSmall={true}
          leftPosition={150}
        >
          <ToolsMenuContainer>
            <ToolsListContainer>
              <div className="tools-header">
                {TOOL_HEADER_1_OPTIONS.map(tool => {
                  return (
                      <li className="tool-item" key={tool.key}>
                        <Link to={tool.link}>
                          <span>{tool.value}</span>
                        </Link>
                      </li>
                  );
                })}
              </div>
              <div className="tools-header">
                {TOOL_HEADER_2_OPTIONS.map(tool => {
                  return (
                    <li className="tool-item" key={tool.key}>
                      {tool.key === 2 || tool.key === 1 ? (
                        localStorage.getItem("project_info") &&
                        JSON.parse(localStorage.getItem("project_info"))[
                          "is_owner"
                        ] ? (
                          <Link to={tool.link}>
                            <span>{tool.value}</span>
                          </Link>
                        ) : (
                          <a
                            className="disable-link"
                            title="تنها مدیر پروژه مجاز به ورود به این قسمت می‌باشد."
                          >
                            <span>{tool.value}</span>
                          </a>
                        )
                      ) : (
                        <Link to={tool.link}>
                          <span>{tool.value}</span>
                        </Link>
                      )}
                    </li>
                  );
                })}
              </div>
              {TOOL_MAIN_OPTIONS.map(tool => {
                return (
                  <li className="tool-item" key={tool.key}>
                    <Link to={tool.link}>
                      <span>{tool.value}</span>
                    </Link>
                  </li>
                );
              })}
              <div className="tools-footer">
                {TOOL_FOOTER_OPTIONS.map(tool => {
                  if (
                    init.data &&
                    init.data.data &&
                    init.data.data.project &&
                    (init.data.data.project.premium_state === FREE ||
                      init.data.data.project.premium_state ===
                        EXPIRED_PREMIUM) &&
                    tool.key === 1
                  )
                    return (
                      <li className="tool-item" key={tool.key}>
                        <div
                          className="disabled-a"
                          onClick={() =>
                            this.setState({ featureLimitModalShow: true })
                          }
                        >
                          <span>{tool.value}</span>
                          <i className="icon mapsa-premium-plan" />
                        </div>
                      </li>
                    );
                  else {
                    return (
                      <li className="tool-item" key={tool.key}>
                        <Link to={tool.link}>
                          <span>{tool.value}</span>
                        </Link>
                      </li>
                    );
                  }
                })}
              </div>
            </ToolsListContainer>
          </ToolsMenuContainer>
        </Menu>
      </React.Fragment>
    );
  }
}
const mapStateToProps = store => {
  return {
    init: store.Init
  };
};

export default connect(
  mapStateToProps,
  null
)(withRouter(Index));
